import {
  getMerchandiseProducts
} from "./chunk-NX7DX2HC.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/merchandise/listing.ts
import { useInfiniteQuery } from "@tanstack/react-query";
var useMerchandiseProducts = (props) => {
  return useInfiniteQuery({
    queryKey: ["merchandiseProducts", props],
    queryFn: ({ pageParam = 1 }) => getMerchandiseProducts(__spreadProps(__spreadValues({}, props), { page: pageParam })),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { current_page, total_pages } = lastPage.pagination;
      return current_page < total_pages ? lastPageParam + 1 : void 0;
    },
    initialPageParam: 1,
    select: (data) => data.pages.flatMap((page) => page.products)
  });
};

export {
  useMerchandiseProducts
};
//# sourceMappingURL=chunk-K6HDPFOR.mjs.map